import { getRoutesList } from '@lmp/eduki-routes';
import i18n from 'i18next';
import { world } from '../languages';

const ROUTES = getRoutesList(world, i18n);

export default ROUTES;
